import { useRoutes } from 'react-router';

import initialRoutes from './initialRoutes';

export default function BaseRoutes() {
  return useRoutes([initialRoutes]);
}
